import React from 'react';
import PropTypes from 'prop-types';
import {
  FieldInputProps,
  FieldMetaProps,
} from '../../Constants/ReduxFormPropTypes';
import DollarsAndCents from '../DollarsAndCents';
import CurrencyHelper from '../../Helpers/CurrencyHelper';
import { CheckboxInput } from '@jauntin/react-ui';

const HostLiquorField = ({ input, meta, disabled }) => (
  <>
    <div className="col-auto w--70 label">
      <DollarsAndCents
        currency={new CurrencyHelper().setValue(0)}
        cents={false}
      />
    </div>
    <div className="col">
      <label
        htmlFor={input.name}
        className={
          meta.touched && meta.error ? 'label form-error__label' : 'label'
        }
      >
        Host Liquor (included)
      </label>
      {meta.touched && meta.error && <span>{meta.error}</span>}
    </div>
    <div className="col-auto">
      <CheckboxInput
        input={input}
        meta={meta}
        showErrors={() => false}
        disabled={disabled}
        label={<>&nbsp;</>}
      />
    </div>
  </>
);
HostLiquorField.propTypes = {
  input: FieldInputProps.isRequired,
  meta: FieldMetaProps.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default HostLiquorField;
